class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.overlay = document.querySelector('.header__menu-overlay') || this.createOverlay();
    this.connectOverlay();
  }

  createOverlay() {
    const overlay = document.createElement('div');
    overlay.className = 'header__menu-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);
    return overlay;
  }

  connectOverlay() {
    if (!this.overlay) return;

    if (!this.overlay.dataset.bound) {
      this.overlay.addEventListener('click', () => {
        document.querySelectorAll('header-menu').forEach((menu) => menu.close());
        const menuDrawer = document.querySelector('header-drawer details[open]');
        if (menuDrawer) {
          const summary = menuDrawer.querySelector('summary');
          summary && summary.click();
        }
      });

      this.overlay.dataset.bound = true;
    }
  }

  onToggle() {
    super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    this.toggleOverlay();

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    super.close();
    this.toggleOverlay();
  }

  toggleOverlay() {
    this.overlay = this.overlay || document.querySelector('.header__menu-overlay');
    const anyOpen = !!document.querySelector('header-menu details[open]');

    if (this.header) {
      this.header.classList.toggle('header-wrapper--menu-open', anyOpen);
    }

    if (this.overlay) {
      this.overlay.classList.toggle('is-visible', anyOpen);
      this.overlay.toggleAttribute('aria-hidden', !anyOpen);
    }

    document.body.classList.toggle('header-menu-open', anyOpen);
  }
}

customElements.define('header-menu', HeaderMenu);
